import { useState, useEffect } from "react";

const useInfiniteScroll = (callback) => {
  const [isFetching, setIsFetching] = useState<any>(false);
  const [isEnded, setIsEnded] = useState<any>(false);

  useEffect(() => {
    function handleScroll() {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      const scrollThreshold = 0.8;

      if (
        scrollY + windowHeight >= documentHeight * scrollThreshold &&
        !isFetching &&
        !isEnded
      ) {
        callback();
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isFetching, isEnded]);

  return [isFetching, setIsFetching, isEnded, setIsEnded];
};

export default useInfiniteScroll;
